var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-13 mt-md-3 text-right"},[_c('div',{staticClass:"my-account link",on:{"click":_vm.selectAccount}},[_c('font-awesome-icon',{staticClass:"font-awesome-icon",attrs:{"icon":"user-circle"}}),_vm._v("\n    "+_vm._s(_vm.userName)+"\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }